import React, { useState } from 'react';
import { Button } from 'react-bootstrap';

import MessageModal from './MessageModal.jsx';

const SendMessage = ({ user }) => {
  const [messageUser, setMessageUser] = useState(null);

  return (
    <>
      <div className="message-btn-container">
        <Button
          className="profile-button btn-black"
          onClick={() => setMessageUser(user)}
          data-test="message-button"
        >
          Send A Message
        </Button>
      </div>
      <MessageModal user={messageUser} onClose={() => setMessageUser(null)} />
    </>
  );
};

export default SendMessage;
